module.exports = __webpack_public_path__ + "img/icontype3.d9980c5b.png";